import {
  BaSeButton,
  BaSeDialogContext,
  BaSeInput,
  BaSeOptionPicker,
  BaSeTheme,
} from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import React from 'react';
import { USER_ENDPOINT } from '../../hooks/constants';

export const ModalChangeValueCertificado = ({
  isChangeTemplate,
  listTemplates,
  notify,
  onClose,
  save,
  cpf,
  // eslint-disable-next-line sonarjs/cognitive-complexity
}) => {
  const [selectedTemplate, setSelectedTemplate] = React.useState(null);
  const [newNameClient, setNewNameClient] = React.useState(null);
  const [loading, setLoading] = React.useState(-1);

  const { backendGet } = Sebrae.useBackend();
  const { showNotification } = React.useContext(BaSeDialogContext);

  const handleSave = React.useCallback(async () => {
    setLoading(0);

    const { sucess, message } = await save(
      isChangeTemplate ? selectedTemplate : newNameClient,
    );
    if (sucess) {
      notify({
        message: 'Dados salvos com sucesso!',
        color: 'confirmation',
      });
      setLoading(-1);
      return onClose?.closeModal?.();
    } else {
      notify({
        message,
        color: 'destructive',
      });
    }
    setLoading(false);
  }, [
    isChangeTemplate,
    newNameClient,
    notify,
    onClose,
    save,
    selectedTemplate,
  ]);

  const handleSearchAmei = React.useCallback(() => {
    setLoading(1);
    const cpfFormat = cpf.replace(/\D/g, '');
    backendGet(`${USER_ENDPOINT}/${cpfFormat}`)
      .then((data) => {
        setNewNameClient(data.nome);
      })
      .catch((error) =>
        showNotification({
          message: 'Não foi possível recuperar nome!',
          color: 'destructive',
        }),
      )
      .finally(() => setLoading(-1));
  }, [backendGet, cpf, showNotification]);

  return (
    <>
      <div style={{ height: isChangeTemplate ? 300 : 'auto' }}>
        {isChangeTemplate ? (
          <BaSeOptionPicker
            color="default"
            emptyValueLabel="Selecione"
            enableSelectAll
            initialSelectedValuesId={[]}
            label="Novo template"
            maxMenuHeight="100px"
            maxOptionsSelected={1}
            moreInfoLabel="Atenção, o novo template será aplicado em todos os certificados selecionados."
            onChange={(item) => setSelectedTemplate(item?.[0]?.id)}
            overrideColors={{
              moreInfo: BaSeTheme.colors.feedbackInterface.erro35,
            }}
            searchPlaceholder="Procurar template"
            size="medium"
            values={listTemplates}
            width={350}
          />
        ) : (
          <BaSeInput
            align="start"
            color="default"
            isLoading={loading === 1}
            iconButton={{
              action: handleSearchAmei,
              color: undefined,
              name: 'search',
              type: undefined,
              typeButton: 'base-button',
              value: 'Buscar no AMEI',
            }}
            overrideColors={{
              moreInfo: BaSeTheme.colors.feedbackInterface.erro35,
            }}
            inputMode="text"
            label="Novo nome"
            moreInfoLabel="Atenção, o novo nome será aplicado em todos os certificados selecionados."
            onChange={setNewNameClient}
            placeholder="Digite o nome ou busque no AMEI"
            size="small"
            typeInput="text"
            value={newNameClient}
            width="100%"
          />
        )}
      </div>
      <div style={{ marginTop: 20, display: 'flex', gap: 10 }}>
        <BaSeButton
          isLoading={loading === 0}
          isDisabled={
            (isChangeTemplate && !selectedTemplate) ||
            (!isChangeTemplate && !newNameClient)
          }
          color={BaSeTheme.colors.feedbackInterface.sucesso26}
          value="Alterar"
          onClick={handleSave}
        />
        <BaSeButton
          type="secondary"
          color={BaSeTheme.colors.institucionais.azulSebrae36}
          value="Cancelar"
          onClick={() => onClose?.closeModal?.()}
        />
      </div>
    </>
  );
};
